
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');
var jQueryBridget = require('jquery-bridget');
require('bootstrap-sass');
window.bootbox = require('bootbox');
require('jquery.panzoom');
require('jquery-mousewheel');
require('./jquery-ui');
require('./tinymce-editor');
require('imagesloaded');
window.Masonry = require('masonry-layout');
jQueryBridget('masonry', window.Masonry, window.$);
/**
 * @deprecated croppie
 */
require('croppie');
//require('datatables.net');
require('datatables.net-bs');
require('jquery-lazy');
/**
 * @deprecated blueimp-gallery
 */
require('blueimp-gallery');
window.Cookies = require('js-cookie');
window.moment = require('moment');
import 'moment/locale/zh-tw';
window.loadImage = require('blueimp-load-image');
require('jquery.filer');
window.PhotoSwipe = require('photoswipe');
window.PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');
require('./lib/e-smart-zoom-jquery');

require('material-design-lite');

require('parsleyjs');
require('parsleyjs/dist/i18n/zh_tw');

require('select2');

// try to remove this plugin ( used by Cheung before )
/**
 * @deprecated tablesorter
 */
require('tablesorter');
window.Pikaday = require('pikaday');

window.SmartBanner = require('smart-app-banner');
require('dotdotdot');

window.jQuery.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        'X-Requested-With': 'XMLHttpRequest',
    }
});


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
};

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    window.axios.defaults.headers.common['Authorization'] = "Bearer" + localStorage.getItem('laravel_token');
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.Dropzone = require('dropzone');

